import React, { ChangeEvent, PropsWithChildren } from 'react';

interface CheckboxProps {
  value?: string;
  id: string;
  label?: string;
  checked: boolean;
  name: string;
  className?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}
export const Checkbox = ({
  value,
  id,
  label,
  checked,
  name,
  className,
  onChange,
  children,
}: PropsWithChildren<CheckboxProps>) => {
  return (
    <div
      className={`relative flex h-auto w-auto items-center ${
        className ? className : ''
      }`}
    >
      <label htmlFor={id} className="flex">
        <input
          className="peer sr-only"
          type="checkbox"
          name={name}
          checked={checked}
          value={value}
          id={id}
          onChange={onChange}
        />
        <span
          className="
          mr-3.5
         inline-grid
         h-6
          min-w-[1.5rem]
          place-items-center
          rounded-sm
          border
          border-neutral-grey-400
          bg-brand-white
          fill-brand-white
        align-middle
          hover:bg-brand-white
          hover:fill-icon-light
          peer-checked:bg-neutral-grey-700
          peer-checked:fill-brand-white
          peer-checked:hover:bg-neutral-grey-400
          peer-checked:hover:fill-brand-white
          peer-focus-visible:bg-brand-white
          peer-focus-visible:outline
          peer-focus-visible:outline-3
          peer-focus-visible:outline-offset-3
          peer-focus-visible:outline-neutral-grey-400
          peer-checked:peer-focus-visible:fill-neutral-grey-700
          "
        >
          <svg
            fill="currentFill"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 10"
            width={12}
            height={10}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.6.2a1 1 0 0 1 .2 1.4l-6 8a1 1 0 0 1-1.507.107l-4-4a1 1 0 0 1 1.414-1.414l3.185 3.185L10.2.4a1 1 0 0 1 1.4-.2Z"
            />
          </svg>
        </span>
        {label ? label : children}
      </label>
    </div>
  );
};
